import React, { useEffect, useState } from 'react';
import * as styles from './heroImage.module.scss';
import Img from 'gatsby-image'

export const HeroImage = ({ data }) => {
    const { image, mobileImage } = data;
    let [isDomLoaded, setIsDomLoaded] = useState(false)
    useEffect(() => {
        setIsDomLoaded(true)
    }, []);
    return (
        <div className={styles.fs}>
            <div className={`container container-fs`} style={{ visibility: isDomLoaded ? "visible" : "hidden" }}>
                {image && (
                    <Img fadeIn={true} fluid={image.fluid} alt={image.title} className={`${styles.image} ${styles.imageDesktop}`} loading="eager" />
                )}
                {image && (
                    <Img fadeIn={true} fluid={(mobileImage || image).fluid} alt={image.title} className={`${styles.image} ${styles.imageMobile}`} loading="eager" />
                )}
            </div>
        </div>
    );
}

export default HeroImage;